//Data Layer Events for the hometool to improve GTM/GA4 reporting

export const pushHomeToolEvent = (eventName, eventData = {}) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    tool_name: 'interactive_home_tool',
    ...eventData,
  });
};